export default {
    load: () => (JSON.parse(localStorage.getItem('app_settings', "{}"))),
    save: (data) => {
        localStorage.setItem('app_settings', JSON.stringify(data))
    }
}
